'use client'
import { createContext, useContext, ReactNode, useState } from 'react'

type BreadcrumbLabels = {
  [key: string]: string
}

type BreadcrumbContextType = {
  setDynamicLabel: (path: string, label: string) => void
  getDynamicLabel: (path: string) => string | null
}

const BreadcrumbContext = createContext<BreadcrumbContextType | null>(null)

export function BreadcrumbProvider({ children }: { children: ReactNode }) {
  const [labels, setLabels] = useState<BreadcrumbLabels>({})

  const setDynamicLabel = (path: string, label: string) => {
    if (labels[path] !== label) {
      setLabels((prev) => ({
        ...prev,
        [path]: label,
      }))
    }
  }

  const getDynamicLabel = (path: string) => {
    return labels[path] || null
  }

  return (
    <BreadcrumbContext.Provider value={{ setDynamicLabel, getDynamicLabel }}>
      {children}
    </BreadcrumbContext.Provider>
  )
}

export const useBreadcrumb = () => {
  const context = useContext(BreadcrumbContext)
  if (!context) {
    throw new Error('useBreadcrumb must be used within a BreadcrumbProvider')
  }
  return context
}
